<template>
  <div>
    <Headersys />
    <div class="content">
      <div>
        设置本机编码
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="终端名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="所在区域+终端位置"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机器编码" prop="code">
              <el-input v-model="ruleForm.code" placeholder="机器编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="终端地址" prop="address">
              <el-input v-model="ruleForm.address" placeholder="终端所在位置"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="MAC地址" prop="mac">
              <el-input v-model="ruleForm.mac" placeholder="MAC地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">设置编码</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Back />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      ruleForm: {
        name: "", //终端名称
        code: "", //机器编码
        address: "", //终端地址
        mac: "", //mac地址
        // fregorg: "370705", //区划码
        // fliaison: "", //联系人
        // fphone: "", //手机号
      },
      rules: {
        name: [
          { required: true, message: '请输入终端名称', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入终端机器编码', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入终端地址', trigger: 'blur' },
        ],
        mac: [
          { required: true, message: '请输入MAC地址', trigger: 'blur' },
        ],
      }
    };
  },
  created() {
  },
  mounted() {
    this.getMac()
  },
  methods: {
    getMac() {
      this.$fun.getMAC(mac => {
        this.ruleForm.mac = mac;
        this.checkCode()
      })
    },
    checkCode() {
      this.$rqt.terminalDevice_queryByMac(this.ruleForm.mac).then(res => {
        console.log('查询', res);
        if (res.data) {
          this.ruleForm = res.data
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$rqt.terminalDevice_addMac(this.ruleForm).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000);
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getMac()
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>